import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppliedJobList from "../AppliedJobList/AppliedJobList";
import BulkApplyList from "../BulkApplyList/BulkApplyList";
import { CloseButton, HeaderStyled } from "../styles";
import {
  ArrowDownIcon,
  CloseLink,
  CollapsibleContainer,
  SecondaryHeaderContainer,
  SecondaryWrapper,
} from "./styles";

export default function SecondaryBulkApply(props) {
  const {
    dialog,
    selectedJobs,
    showList,
    setShowList,
    setSelectedJobs,
    recommendedJobs,
    filteredJobs,
    jobAlert,
    setViewedCards,
    fetchingJobs,
    jobListRef,
    currentTab,
    origin,
  } = props;

  const { t } = useTranslation();

  const jobs = jobAlert ?? useSelector((state) => state?.jobs?.bulkAppliedJobs);

  const fetchingRecommendedJobs = useSelector(
    (state) => state?.jobs.fetchingRecommendedJobs
  );

  const jobAlertApplyExist = jobAlert?.length > 0;

  function handleClose() {
    setShowList(false);
  }

  function handleToggleList() {
    setShowList(!showList);
  }

  const headerText = jobAlertApplyExist
    ? t("jobs.secondary_bulk_apply.header_job_alert")
    : t("jobs.secondary_bulk_apply.header_applied_count", {
        count: jobs?.length ?? 0,
        suffix: jobs?.length === 1 ? "" : "s",
        view_all: showList
          ? ""
          : t("jobs.secondary_bulk_apply.view_all_suffix"),
      });

  return (
    jobs?.length !== 0 && (
      <SecondaryWrapper
        open={showList}
        dialog={dialog}
        jobAlert={jobAlertApplyExist}
      >
        <SecondaryHeaderContainer
          open={showList}
          dialog={dialog}
          jobAlert={jobAlertApplyExist}
          onClick={handleToggleList}
        >
          <HeaderStyled size={"secondary"} jobAlert={jobAlertApplyExist}>
            {headerText}
          </HeaderStyled>
          <CloseButton onClick={handleToggleList}>
            <ArrowDownIcon open={showList} />
          </CloseButton>
        </SecondaryHeaderContainer>
        <CollapsibleContainer dialog={dialog} in={showList}>
          <AppliedJobList jobs={jobs} />
          <CloseLink onClick={handleClose}>
            {t("jobs.secondary_bulk_apply.close_list")}
          </CloseLink>
        </CollapsibleContainer>
        {dialog ? (
          <BulkApplyList
            dialog={dialog}
            secondaryBulk={true}
            showList={showList}
            selectedJobs={selectedJobs}
            setSelectedJobs={setSelectedJobs}
            fetchingJobs={fetchingJobs}
            jobs={filteredJobs}
            recommendedJobs={recommendedJobs}
            setViewedCards={setViewedCards}
            jobListRef={jobListRef}
            currentTab={currentTab}
            origin={origin}
          />
        ) : null}
      </SecondaryWrapper>
    )
  );
}
